// Dias de atendimento do doutor. A tela trabalha com os 7 dias; a API, com a lista de horários
// (service_hours: [{ week_day, start_time, end_time }]). Horários são textos 'HH:mm', sem fuso.

export const WEEK_DAY_NAMES = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado']; // índice = week_day (0 = domingo, igual ao getDay)
export const DEFAULT_WEEK_DAYS = [1, 2, 3, 4, 5]; // doutor novo: segunda a sexta, como a migration
export const DEFAULT_PERIODS = [{ start_time: '08:00', end_time: '12:00' }, { start_time: '13:30', end_time: '18:00' }];
export const SERVICE_PERIODS_MAX_PER_DAY = 6; // mesmo limite do backend

const isValidTime = (text) => /^([01]\d|2[0-3]):[0-5]\d$/.test(text ?? '');
const byStart = (a, b) => a.start_time.localeCompare(b.start_time);

export const copyDefaultPeriods = () => DEFAULT_PERIODS.map((period) => ({ ...period }));

// API -> 7 dias. Sem lista (doutor novo), segunda a sexta ficam ligados.
// Dia desligado já guarda os dois horários padrão, que aparecem se ele for ligado
export function buildServiceDays(serviceHours) {
  return WEEK_DAY_NAMES.map((_, weekDay) => {
    if (!serviceHours) return { week_day: weekDay, activated: DEFAULT_WEEK_DAYS.includes(weekDay), periods: copyDefaultPeriods() };

    const periods = serviceHours
      .filter((hour) => hour.week_day === weekDay)
      .map(({ start_time, end_time }) => ({ start_time, end_time }))
      .sort(byStart);

    return periods.length > 0
      ? { week_day: weekDay, activated: true, periods }
      : { week_day: weekDay, activated: false, periods: copyDefaultPeriods() };
  });
}

// 7 dias -> API: só os dias ligados, um item por horário, em ordem de dia e início
export function buildServiceHours(serviceDays) {
  return serviceDays
    .filter((day) => day.activated)
    .flatMap((day) => [...day.periods].sort(byStart).map(({ start_time, end_time }) => ({ week_day: day.week_day, start_time, end_time })));
}

// Mesmas regras e mensagens do backend; confere só os dias ligados. Devolve a 1ª mensagem ou null
export function validateServiceDays(serviceDays) {
  const activeDays = serviceDays.filter((day) => day.activated);
  if (activeDays.length === 0) return 'Ligue pelo menos um dia de atendimento.';

  for (const day of activeDays) {
    const name = WEEK_DAY_NAMES[day.week_day];

    if (day.periods.length === 0) return `${name}: informe pelo menos um horário.`;
    if (day.periods.length > SERVICE_PERIODS_MAX_PER_DAY) return `${name}: informe no máximo ${SERVICE_PERIODS_MAX_PER_DAY} horários.`;
    if (day.periods.some((period) => !isValidTime(period.start_time) || !isValidTime(period.end_time))) return `${name}: informe o início e o fim de todos os horários.`;

    const invalid = day.periods.find((period) => period.end_time <= period.start_time);
    if (invalid) return `${name}: o horário ${invalid.start_time} até ${invalid.end_time} precisa terminar depois de começar.`;

    // Encostados (até 12:00 e desde 12:00) podem; sobrepostos não
    const sorted = [...day.periods].sort(byStart);
    for (let index = 1; index < sorted.length; index++)
      if (sorted[index].start_time < sorted[index - 1].end_time)
        return `${name}: os horários ${sorted[index - 1].start_time} até ${sorted[index - 1].end_time} e ${sorted[index].start_time} até ${sorted[index].end_time} se sobrepõem.`;
  }

  return null;
}
